module.exports = __webpack_public_path__ + "static/media/Tana_Hill_Bylaws.4d013635.pdf";